module.exports = __webpack_public_path__ + "img/课程体系.4760a34e.png";